<template>
    <div class="container-fluid py-4">
        <template v-if="isLoading">
            <div class="d-flex justify-content-center w-100 p-5 text-info font-weight-bold text-lg">
                Cargando datos ...
            </div>
        </template>
        <template v-else>
            <div class="card">
                <div class="card-header pb-2">
                    <h5 class="mb-1 text-success">Rutas Infantiles</h5>
                    <p class="text-sm text-secondary mb-0">{{ routes.length }} rutas</p>
                </div>
                <div class="card-body pt-2">
                    <ul class="list-group">
                    <li
                        v-for="(route, index) in routes"
                        :key="index"
                        class="list-group-item d-flex flex-wrap justify-content-between align-items-center gap-2 px-0 py-3 border-0 border-bottom"
                    >
                        <h6 class="text-dark font-weight-bold text-sm mb-0">
                            {{ route.name }}
                        </h6>
                        <div class="d-flex align-items-center gap-3">
                            <span class="badge bg-gradient-secondary">{{ route.members_count }} participantes</span>
                            <div class="dropdown download-actions">
                                <a
                                    :id="`download-route-${route.id}`"
                                    class="download-menu-trigger cursor-pointer"
                                    href="javascript:;"
                                    :aria-expanded="openDownloadMenu === `route-${route.id}`"
                                    aria-label="Opciones de descarga"
                                    @click.stop.prevent="toggleDownloadMenu(`route-${route.id}`)">
                                    <i class="fas fa-download text-secondary" aria-hidden="true"></i>
                                </a>
                                <ul
                                    class="dropdown-menu dropdown-menu-end px-2 py-3"
                                    :class="{ show: openDownloadMenu === `route-${route.id}` }"
                                    :aria-labelledby="`download-route-${route.id}`">
                                    <li>
                                        <a href="javascript:;" class="dropdown-item border-radius-md" @click.stop.prevent="downloadRoute(route, 'excel')">
                                            <i class="fas fa-file-excel text-success me-2" aria-hidden="true"></i>
                                            Descargar Excel
                                        </a>
                                    </li>
                                    <li>
                                        <a href="javascript:;" class="dropdown-item border-radius-md" @click.stop.prevent="downloadRoute(route, 'pdf')">
                                            <i class="fas fa-file-pdf text-danger me-2" aria-hidden="true"></i>
                                            Descargar PDF
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </li>
                    </ul>
                </div>
            </div>
        </template>
    </div>
    
</template>

<script>
import axios from 'axios';
const PUBLIC_API_URL = process.env.VUE_APP_PUBLIC_API_URL;
export default {
    name: "routes-infant-list",
    data() {
        return {
            isLoading: false,
            routes: [],
            openDownloadMenu: null
        }
    },
    mounted() {
        this.fetchRoutes();
    },
    methods:{
        async fetchRoutes(){
            this.isLoading = true;
            try {
                const response = await axios.get(`${PUBLIC_API_URL}/routes/count`);
                this.routes = response.data;
            } catch (error) {
                this.isLoading = false;
            }
            this.isLoading = false;
        },
        downloadRoute(route, format) {
            this.downloading = true;
            this.openDownloadMenu = null;
            const id = route.id;
            const name = encodeURIComponent(route.name);
            const url = `${PUBLIC_API_URL}/route/${id}/participants/infant?route_name=${name}&format=${format}`;
            const link = document.createElement('a');
            link.href = url;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.downloading = false;
        },
        toggleDownloadMenu(key) {
            this.openDownloadMenu = this.openDownloadMenu === key ? null : key;
        },
    }
}
</script>

<style scoped>
.download-actions {
    display: inline-flex;
}

.download-menu-trigger {
    align-items: center;
    border-radius: 50%;
    display: inline-flex;
    height: 1.75rem;
    justify-content: center;
    transition: background-color 0.15s ease, color 0.15s ease;
    width: 1.75rem;
}

.download-menu-trigger:hover,
.download-menu-trigger:focus {
    background-color: rgba(52, 71, 103, 0.1);
    outline: none;
}
</style>
